// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__8k21l","error":"InputSecondary_error__1XFUo","disabled":"InputSecondary_disabled__3xMnE"};